export default "__VITE_ASSET__13d89ede__"